import React from 'react';
import { connect } from 'react-redux';
import { lzCallApi } from '../../../../services/LzApiService';
import { lzShowSuccessMessage } from '../../../../services/LzUtils';
import LzForm from '../../../commons/forms/form';
import PrivateLayout from '../../../layouts/private';
import Container from '@material-ui/core/Container';
import LzFormFieldInput from '../../../commons/forms/fields/input';

class ChangePasswordScreen extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            model: this.getInitFormValues(),
        };
    }

    getInitFormValues() {
        return {
            oldWp: '',
            newWp: '',
            cfmWp: '',
        };
    }

    handleInputChange = (name, value) => {
        this.setState({ model: Object.assign({}, this.state.model, { [name]: value }) });
    };

    async save() {
        const { model } = this.state;

        // Make the api call and get processed data
        const data = await lzCallApi('password', model, 'post');

        // Check if call was successful
        if (data) {
            lzShowSuccessMessage('Your password is successfully changed!');
            this.setState({ model: this.getInitFormValues() });
        }
    }

    render() {
        const { model } = this.state;

        return (
            <PrivateLayout screenTitle="Change Password">
                <div className={'lz-form-page lz-form-page-medium'}>
                    <Container maxWidth="sm">

                        <LzForm noCancel showReset size="sm" onSubmit={() => this.save()}>

                            <LzFormFieldInput fluid required noAutocomplete type="password" label="Old Password"
                                name="oldWp" value={model.oldWp} onChange={this.handleInputChange} autoFocus />

                            <LzFormFieldInput fluid required noAutocomplete type="password" label="New Password"
                                name="newWp" value={model.newWp} onChange={this.handleInputChange} />

                            <LzFormFieldInput fluid required noAutocomplete type="password" label="Confirm Password"
                                name="cfmWp" value={model.cfmWp} onChange={this.handleInputChange} />

                        </LzForm>

                    </Container>
                </div>
            </PrivateLayout>
        );
    }

}

const mapStateToProps = (state) => {
    return {
        loading: state.commons.loading,
    }
};

export default connect(
    mapStateToProps
)(ChangePasswordScreen);
